import dayjs from 'dayjs';
import { isNil } from '../isNil';
export var parseValueToDay = function parseValueToDay(value, formatter) {
  if (isNil(value) || dayjs.isDayjs(value)) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(function (v) {
      return parseValueToDay(v, formatter);
    });
  }

  if (typeof value === 'number') return dayjs(value);
  return dayjs(value, formatter);
};